import React from "react";
import { fireGtmEvent } from "../../utils/functions";
import Title from "@airasia/phoenix-components/components/Title";
import CardInfo from "@airasia/phoenix-components/components/CardInfo";

function DiscountWrapper({ promoData }) {
  return (
    <div>
    <Title
        accessible
        inverted={false}
        textAlign="left"
        theme="AIRASIA_CLASSIC"
        type="h2"
        customProperties={{id: 'subtitle'}}
      >
      </Title>
        <CardInfo
          accessible
          bgColor="greyDark"
          hasBorder
          hasBoxShadow
          hasHeader
          hasTextToggle={false}
          icon="DiscountPromoLogo"
          iconPosition="left"
          iconSize="titleLarge"
          imgHeight="40px"
          imgWidth="50px"
          isMobile={false}
          theme="AIRASIA_CLASSIC"
          data={promoData}
          titleFirst
          titleType={{
            color: '',
            type: 'default'
          }}
        />
    </div>
  );
}

export default DiscountWrapper;
